export default __webpack_public_path__ + "static/media/09.781421af.jpg";